import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type Organization = any;

export interface OrganizationState {
    organizations: Organization[];
    selectedOrganizationId: number | null;
    loading: boolean;
    error: any;
}

const INITIAL_STATE_ORGANIZATIONS: OrganizationState = {
    organizations: [],
    selectedOrganizationId: null,
    loading: false,
    error: null
}

const organizationsSlice = createSlice({
    name: 'organizations',
    initialState:  INITIAL_STATE_ORGANIZATIONS,
    reducers: {
        setOrganizations: (state, action: PayloadAction<Organization[]>) => {
            state.organizations = action.payload;
        },
        setLoadingOrganizations: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setSelectedOrganizationId: (state, action: PayloadAction<number | null>) => {
            state.selectedOrganizationId = action.payload;
        },
    }
})

export const { 
    setOrganizations,
    setLoadingOrganizations,
    setSelectedOrganizationId
} = organizationsSlice.actions;

export default organizationsSlice.reducer;